/**
 * Utility functions for generating product URLs
 */

/**
 * Generate a static URL for a specific product item
 * @param {string} categoryName - The category/group name (e.g., "Li-po")
 * @param {string} itemcode - The item code (e.g., "AKY0080")
 * @returns {string} - The generated URL path
 */
export const generateProductItemUrl = (categoryName, itemcode) => {
  if (!categoryName || !itemcode) {
    throw new Error('Both categoryName and itemcode are required');
  }
  
  return `/products/${encodeURIComponent(categoryName)}/list/${encodeURIComponent(itemcode)}`;
};

/**
 * Generate a URL for a product category list
 * @param {string} categoryName - The category/group name (e.g., "Li-po")
 * @returns {string} - The generated URL path
 */
export const generateProductCategoryUrl = (categoryName) => {
  if (!categoryName) {
    throw new Error('categoryName is required');
  }
  
  return `/products/${encodeURIComponent(categoryName)}/list`;
};

/**
 * Parse product URL to extract category and itemcode
 * @param {string} pathname - The URL pathname
 * @returns {object} - Object containing categoryName and itemcode (if present)
 */
export const parseProductUrl = (pathname) => {
  const match = pathname.match(/^\/products\/([^\/]+)\/list(?:\/([^\/]+))?$/);
  
  if (!match) {
    return { categoryName: null, itemcode: null };
  }
  
  return {
    categoryName: decodeURIComponent(match[1]),
    itemcode: match[2] ? decodeURIComponent(match[2]) : null
  };
}; 